import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./App";
import { PageError } from "./shell/PageError";
import "./styles/linnfoss-palette.css";
import "./styles/linnfoss-typography.css";
import "./styles/linnfoss-type-roles.css";
import "./styles/theme.css";

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <PageError>
      <App />
    </PageError>
  </StrictMode>,
);
